module.exports = __webpack_public_path__ + "static/media/VanWalksLogo.a972e131.png";